'use client'
import { type FC } from 'react'
import styled from 'styled-components'
import { useTranslator } from '@/hooks'
import { useParams } from 'next/navigation'
import { mq, vw, font15_15, font30_32, font50_52, createUnderline } from '@/styles'

type Props = {
  data: any
}


export const SectionLegal: FC<Props> = ({ data }) => {
  const { t } = useTranslator()
  const { lang } = useParams()

  return (
    <Section>
      <h1>{t('layout.nav.legal')}</h1>
      {data[lang as string].map((section: string[]) => section)}
    </Section>
  )
}
const Section = styled.section`
  align-content: center;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${vw(80, 'mobile')};
  margin: ${vw(100, 'mobile')} auto ${vw(60, 'mobile')};
  max-width: 90%;

  ${mq.greaterThan('nexus7')} {
    gap: ${vw(80, 'tablet')};
    margin: ${vw(100, 'tablet')} auto ${vw(60, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    gap: ${vw(100, 'desktop')};
    margin: ${vw(100, 'desktop')} auto ${vw(60, 'desktop')};
  }

  ${mq.greaterThan('desktop-xs')} {
    gap: 100px;
    margin: 80px auto 150px;
    max-width: 990px;
  }

  > h1 {
    ${font15_15(true, 600)}
    color: ${({ theme }) => theme.colors.neon_purple};
    letter-spacing: 1.5px;
    margin: ${vw(50, 'mobile')} auto 0  ;

    ${mq.greaterThan('nexus7')} {
      margin: ${vw(50, 'tablet')} auto 0 ;
    }

    ${mq.greaterThan('tablet')} {
      margin: ${vw(50, 'desktop')} auto 0 ;
      max-width: 990px;
    }

    ${mq.greaterThan('desktop')} {
      margin: 50px auto 0 ;
    }
  }

  article {
    display: flex;
    flex-direction: column;

    h2 {
      ${font30_32(true, 600)}
      color: ${({ theme }) => theme.colors.white};
      margin-bottom: 20px;
      text-align: left;

      ${mq.greaterThan('tablet')} {
        ${font50_52(false, 600)}
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    p:first-of-type {
      margin-bottom: 20px;
    }

    p:last-of-type {
      margin-top: 25px;
    }

    p, 
    li {
      font-size: 18px;
      line-height: 26px;

      ${mq.greaterThan('tablet')} {
        font-size: 24px;
        line-height: 31px;
      }
    }

    a {
      ${createUnderline({ color: 'white', reverse: true})}
    }

    li {
      list-style: disc inside; 
      padding-left: 1.5em;
      text-indent: -1.5em;
    }

    li > ul {
      margin-top: 20px;

      li {
       list-style: disc;
       margin-left: 40px;
      }
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: ${vw(30, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      gap: ${vw(30, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      gap: ${vw(50, 'desktop')};
    }

    ${mq.greaterThan('desktop-xs')} {
      gap: 50px;
    }
  }
`

